/**
 * A clock label whose day mark ("20:00 −1d", "05:00 +1d") reads as a small
 * raised tag instead of four more monospace characters — dense rows (the
 * Drop slots list, 20/10/2026) keep the time, its pin, the country's time
 * and the 🌙 chip on one line without spilling into the next column.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

/** "20:00 −1d" → ["20:00", "−1d"]; a label without a mark → [label, null]. */
export function splitDayMark(label: string): [string, string | null] {
  const at = label.indexOf(' ');
  return at < 0 ? [label, null] : [label.slice(0, at), label.slice(at + 1).trim() || null];
}

export const ClockLabel: FC<{ label: string }> = ({ label }) => {
  const [time, mark] = splitDayMark(label);
  return (
    <>
      {time}
      {mark ? (
        <sup className="ml-0.5 font-sans text-[8.5px] font-medium text-muted-foreground" title={mark.startsWith('−') ? 'The day before' : 'The next day'}>
          {mark}
        </sup>
      ) : null}
    </>
  );
};
